var map = {
	"./logo_cl/logo-10.png": 1551,
	"./logo_cl/logo-11.png": 6812,
	"./logo_cl/logo-12.png": 3694,
	"./logo_cl/logo-1a.png": 9021,
	"./logo_cl/logo-2.png": 9011,
	"./logo_cl/logo-4a.png": 703,
	"./logo_cl/logo-5a.png": 4379,
	"./logo_cl/logo-7.png": 3812,
	"./logo_cl/logo-8.png": 1880,
	"./logo_cl/logo-9.png": 2572,
	"./logo_cl/logo_3a.png": 9562,
	"./logo_dark.png": 3269,
	"./logo_light.png": 2851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6085;